import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PatientsService {

  constructor(private http: HttpClient) { }

  savePatient(data: any) {
    return lastValueFrom(this.http.post(`patient/save`, data));
  }
  PatientList(ev: any) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`patient/getList/${lasyP}`));
  }
  searchByDate(date) {
    return lastValueFrom(this.http.get(`patient/getPatientsByDate/${date}`));

  }
  PatientGetById(id: any) {
    return lastValueFrom(this.http.get(`patient/getById/${id}`));
  }
  getDetails(id: any) {
    return lastValueFrom(this.http.get(`patient/getDetails/${id}`));
  }
  getPatiendId() {
    return lastValueFrom(this.http.get(`patient/getPatientId`));
  }

  getGeneratePatientId() {
    return lastValueFrom(this.http.get(`patient/generatePatientId`));
  }

  getAllDoc(id: any) {
    return lastValueFrom(this.http.get(`patient_image/getAllByPatient/${id}`));
  }
  patientDocGetbyid(id: any) {
    return lastValueFrom(this.http.get(`patient_image/getDocument/${id}`));
  }
  savePatientRoutine(data: any) {
    return lastValueFrom(this.http.post(`patient/saveRoutine`, data));
  }
  PatientTreatmentSave(data: any) {
    return lastValueFrom(this.http.post(`patient_treatment/save`, data));
  }
  PatientPrescriptionSave(data: any) {
    return lastValueFrom(this.http.post(`patient_prescription/save`, data));
  }
  PatientDocumentSave(data: any) {
    return lastValueFrom(this.http.post(`patient_image/save`, data));
  }
  patientTreatmentList(ev: any) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`patient_treatment/getList/${lasyP}`));
  }
  patientInvestigationList(ev: any) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`patient_investigation/getList/${lasyP}`));
  }

  patientPrescriptionList(ev: any) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`patient_prescription/getList/${lasyP}`));
  }

  patientDentalChartList(ev: any) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`patient_examination/getList/${lasyP}`));
  }

  getDentalChart(id: any) {
    return lastValueFrom(this.http.get(`patient/patientDentalChart/${id}`));
  }
  getRecent() {
    return lastValueFrom(this.http.get(`patient/getRecentPatient`));
  }


  MedicalHistoryGet(data: any) {
    return lastValueFrom(this.http.get(`get/patient_illness`, data));
  }
  getTreatmentDataForPatient(id: any) {
    return lastValueFrom(this.http.get(`getById/treatment/${id}`));
  }
  getPatientMedicialHistory(patientId: any) {
    return lastValueFrom(this.http.get(`patient/medicalHistory/${patientId}`));
  }
  getPatientPrescriptionHistory(patientId: any) {
    return lastValueFrom(this.http.get(`patient/getPrescriptionByPatient/${patientId}`));
  }
  getSummary(patientId: any, page = 0) {
    return lastValueFrom(this.http.get(`patient/getSummary/${patientId}/${page}`));
  }
  getListTreatmentByPatient(ev) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`patient_treatment/getList/${lasyP}`));
  }
  getListTreatmentPlanByPatient(ev) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`treatment_plan/getList/${lasyP}`));
  }
  getListPrescritionByPatient(ev) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`patient_prescription/getListItem/${lasyP}`));
  }

  deletePatient(id, data) {
    return lastValueFrom(this.http.delete(`patient/deletePatient/${id}`, data));
  }
  //save Procedure
  saveProcedure(data) {
    return lastValueFrom(this.http.post(`patient_treatment/saveProcedure`, data));
  }
  getProcedure(pid) {
    return lastValueFrom(this.http.get(`patient_treatment/getProcedure/${pid}`));
  }
  //delete 
  deleteTreatment(id, data) {
    return lastValueFrom(this.http.delete(`patient/deleteTreatment/${id}`, data));
  }
  deleteTreatmentPlan(id, data) {
    return lastValueFrom(this.http.delete(`patient/deleteTreatmentPlan/${id}`, data));
  }
  deletePrescription(id, data) {
    return lastValueFrom(this.http.delete(`patient_prescription/deleteItem/${id}`, data));
  }

  saveInvestigation(data: any) {
    return lastValueFrom(this.http.post(`patient_investigation/save`, data));
  }

  saveDentalChart(data: any) {
    return lastValueFrom(this.http.post(`patient_examination/save`, data));
  }

  saveTreatmentPlan(data: any) {
    return lastValueFrom(this.http.post(`treatment_plan/save`, data));
  }

  deleteInvestigation(id, data) {
    return lastValueFrom(this.http.post(`patient_investigation/delete/${id}`, data));
  }

  deletePrescriptionById(id, data) {
    return lastValueFrom(this.http.post(`patient_prescription/delete/${id}`, data));
  }

  deleteTreatmentPlanById(id, data) {
    return lastValueFrom(this.http.post(`treatment_plan/delete/${id}`, data));
  }

  deleteDentalChartById(id, data) {
    return lastValueFrom(this.http.post(`patient_examination/delete/${id}`, data));
  }

  deleteTreatmentById(id, data) {
    return lastValueFrom(this.http.post(`patient_treatment/delete/${id}`, data));
  }

  prescriptionGetById(id: any) {
    return lastValueFrom(this.http.get(`patient_prescription/getById/${id}`));
  }

  treatmentPlanPrint(id: any) {
    return lastValueFrom(this.http.get(`treatment_plan/print/${id}`));
  }

  treatmentPrint(id: any) {
    return lastValueFrom(this.http.get(`patient_treatment/print/${id}`));
  }

  patientPrescriptionPrint(id: any) {
    return lastValueFrom(this.http.get(`patient_prescription/print/${id}`));
  }

  patientInvoicePrint(id: any) {
    return lastValueFrom(this.http.get(`invoice/print/${id}`));
  }

  patientInvoiceBulkPrint(data: any) {
    return lastValueFrom(this.http.post(`invoice/print`, data));
  }

  patientPaymentPrint(id: any) {
    return lastValueFrom(this.http.get(`payment/print/${id}`));
  }

  patientSummary(id: any, date: any) {
    return lastValueFrom(this.http.get(`patient/print/${id}/${date}`));
  }

}
